import React, { Component } from 'react'
import IntractionActionsList from '../IntractionActionsList'
import StagesManager from '../StagesManager'
import FixedView from '../FixedView'
import { checkPermission, translate } from '../../utils/useful'
import importedIcons from '../inputs/icons'

export default class FrameSettingMenu extends Component {


    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.settingView?.hideView()
    }


    render() {
        return (
            <>
                <button className=' flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.settingView.showView() }}>
                    <p className='font-size-13  text-semibold' style={{ color: this.props.colors?.textColor }}>{translate('Settings')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.settingView = el} nodeRef={this.setting} xOffset={this.props.isMobile ? (this.props.language == 'fa' ? 215 : 120) : (this.props.language == 'fa' ? 215 : -10)} bottomOffset={0} topOffset={0} maxWidth={220} >
                    <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>

                                    <IntractionActionsList onClick={() => { this.functionsHandler('frame', 'openPermissions') }} language={this.props.language} data={{ title: "{{lang}}Permissions & access", icon: importedIcons.permisions }} />

                                    {/* <IntractionActionsList onClick={() => { }} language={this.props.language} data={{ title: "{{lang}}tools.Invitation", icon: importedIcons.invitations }} /> */}

                                    <div className='w-100' style={{ margin: '5px 0px', height: 1, background: '#eee' }}>
                                    </div>

                                    <IntractionActionsList onClick={() => { this.functionsHandler('admin', 'openActions') }} language={this.props.language} data={{ title: "{{lang}}Frame's actions", icon: importedIcons.request }} />
                                    <IntractionActionsList onClick={() => { this.functionsHandler('admin', 'openAutomations') }} language={this.props.language} data={{ title: "{{lang}}Workflows & automations", icon: importedIcons.costumizeField }} />

                                    <div className='w-100' style={{ margin: '5px 0px', height: 1, background: '#eee' }}>
                                    </div>

                                    {/* <IntractionActionsList onClick={() => { this.functionsHandler('frame', 'openAddRelevantCollection') }} language={this.props.language} data={{ title: "{{lang}}tools.Add relevant collection", icon: importedIcons.addCollection }} /> */}
                                    <IntractionActionsList onClick={() => { this.functionsHandler('frame', 'openRelatedFrames') }} language={this.props.language} data={{ title: "{{lang}}Related frames", icon: importedIcons.addCollection }} />
                                    <IntractionActionsList onClick={() => { this.functionsHandler('frame', 'openSynchronizations') }} language={this.props.language} data={{ title: "{{lang}}Synchronization", icon: importedIcons.addCollection }} />

                                    <IntractionActionsList onClick={() => { }} language={this.props.language} data={{ title: "{{lang}}Share or Publish", icon: importedIcons.invitations }} />
                                    <IntractionActionsList onClick={() => { this.functionsHandler('admin', 'changePage', ['settings', 'framesettings', this.props.frame?._id]) }} language={this.props.language} data={{ title: "{{lang}}Frame settings", icon: importedIcons.setting }} />


                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
